import React, { useState, useEffect, useRef } from "react";

import { AiOutlineInfoCircle } from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";

var Modal = require("react-bootstrap-modal");

export const PricingAndFee = ({
  onNext,
  onPrev,
  formData,
  setFormData,
  className,
  save,
  updating,
}) => {
  const [stepForm, setStepForm] = useState({
    perNightPrice: formData.perNightPrice,
    extraChargePerGuest: formData.extraChargePerGuest,
    perMonthPrice: formData.perMonthPrice,
    cleaningFee: formData.cleaningFee,
    securityDeposite: formData.securityDeposite,
    lineholderDiscountType: formData.lineholderDiscountType,
    lineholderDiscount: formData.lineholderDiscount,
  });


  const valueRef = useRef(formData);

  const elementRef = useRef(null);

  
  useEffect(() => {
    valueRef.current = {...formData}
  }, [formData])
  
  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    
    const observer = new MutationObserver(() => {
      if (element.classList.contains('tw-hidden')) {
        handleComponentDisappear();
      }
    });
    
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    return () => observer.disconnect();
  }, []);

  const handleComponentDisappear = () => {
    setFormData(valueRef.current);
  };

  const handleStep = (tag, value) => {
    setStepForm({ ...stepForm, [tag]: value });
    valueRef.current = { ...formData, ...stepForm, [tag]: value };
  };

  const handleNextStep = (e) => {
    e.preventDefault();
    valueRef.current = {...formData, ...stepForm}
    setFormData({ ...formData, ...stepForm });
    // if (
    //   stepForm.perNightPrice <= 0 ||
    //   stepForm.perMonthPrice <= 0 ||
    //   stepForm.securityDeposite <= 0 ||
    //   stepForm.extraChargePerGuest <= 0
    // ) {
    //   toast.info("Prices cannot be zero or less.");
    //   return;
    // }
    setTimeout(() => {
      save(stepForm);
      onNext();
    }, 0); 
   
  };
  return (
    <form onSubmit={handleNextStep}>
      <div className={className}  ref={elementRef}>
        <div>
          <h4 className="mb-5 tw-flex tw-justify-start tw-items-center">
            <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white  tw-rounded-full">
              8
            </span>{" "}
            Pricing and Fees
          </h4>
          <div className="row tw-min-h-[60vh]">
            {formData.rentalType === "Entire Place" &&
              (formData.bookingType === "Hot bed" ||
                formData.bookingType === "Flexible") && (
                <div className="col-lg-6 mb-2">
                  <div>
                    <label className="form-label"> Per Night Price</label>
                    <input
                      onChange={(e) => {
                        if (
                          parseInt(e.target.value) >= 1 ||
                          e.target.value == ""
                        ) {
                          handleStep(
                            "perNightPrice",
                            e.target.value
                              ? Math.floor(parseInt(e.target.value))
                              : ""
                          );
                        } else {
                          handleStep("perNightPrice", "");
                        }
                      }}
                      value={stepForm["perNightPrice"]}
                      type="text"
                      name="perNightPrice"
                      className="form-control"
                      placeholder="Per Night Price"
                      required
                    />
                    {formData.rentalType !== "Entire Place" &&
                      formData.bookingType !== "Cold bed" && (
                        <p className="tw-mt-2 tw-flex tw-items-center tw-justify-start">
                          <AiOutlineInfoCircle
                            size={18}
                            className="tw-mx-2 tw-gray-500"
                          />
                          There is no monthly for hot bed and it does not align
                          with the functionality of prompt
                        </p>
                      )}
                  </div>
                </div>
              )}

            {formData.rentalType === "Entire Place" &&
              (formData.bookingType === "Cold bed" ||
                formData.bookingType === "Flexible") && (
                <div className="col-lg-6 mb-2">
                  <div>
                    <label className="form-label"> Per Month Price</label>
                    <input
                      onChange={(e) => {
                        if (
                          parseInt(e.target.value) >= 1 ||
                          e.target.value == ""
                        ) {
                          handleStep(
                            "perMonthPrice",
                            e.target.value
                              ? Math.floor(parseInt(e.target.value))
                              : ""
                          );
                        } else {
                          handleStep("perMonthPrice", "");
                        }
                      }}
                      value={stepForm["perMonthPrice"]}
                      type="text"
                      name="perMonthPrice"
                      className="form-control"
                      placeholder="Per Month Price"
                      required
                    />
                    <p className="tw-mt-2 tw-flex tw-items-center tw-justify-start">
                      ⓘ Prorated if guest checks in after the 1st of the month
                    </p>
                  </div>
                </div>
              )}

            {formData.rentalType === "Entire Place" && (
              <div className="col-lg-6 mb-2">
                <div>
                  <label className="form-label">
                    {" "}
                    Extra Charge Per Guest ($)
                  </label>
                  <input
                    onChange={(e) => {
                      if (
                        parseInt(e.target.value) >= 1 ||
                        e.target.value == ""
                      ) {
                        handleStep(
                          "extraChargePerGuest",
                          e.target.value
                            ? Math.floor(parseInt(e.target.value))
                            : ""
                        );
                      } else {
                        handleStep("extraChargePerGuest", "");
                      }
                    }}
                    value={stepForm["extraChargePerGuest"]}
                    type="number"
                    name="extraChargePerGuest"
                    className="form-control"
                    placeholder="Extra charge per guest"
                    required
                  />
                </div>
              </div>
            )}
            <div className="col-lg-6 mb-2">
              <div>
                <label className="form-label"> Cleaning Fee</label>
                <input
                  onChange={(e) => {
                    if (parseInt(e.target.value) >= 0 || e.target.value == "") {
                      handleStep(
                        "cleaningFee",
                        e.target.value
                          ? Math.floor(parseInt(e.target.value))
                          : ""
                      );
                    } else {
                      handleStep("cleaningFee", "");
                    }
                  }}
                  value={stepForm["cleaningFee"]}
                  type="text"
                  name="cleaningFee"
                  className="form-control"
                  placeholder="Cleaning Fee"
                  required
                />
                {formData.rentalType === "Entire Place" &&
                  formData.bookingType === "Cold bed" && (
                    // <p className="tw-mt-2 tw-flex tw-items-center tw-justify-start">
                    //   <AiOutlineInfoCircle
                    //     size={18}
                    //     className="tw-mx-2 tw-gray-500"
                    //   />
                    //   Charged monthly for guests on autopay or one time for all other bookings
                    // </p>
                    <p className="tw-mt-2 tw-flex tw-items-center tw-justify-start">
                      ⓘ Charged monthly for guests on autopay or one time for
                      all other bookings
                    </p>
                  )}
                {formData.rentalType !== "Entire Place" &&
                  formData.bookingType === "Cold bed" && (
                    <p className="tw-mt-2 tw-flex tw-items-center tw-justify-start">
                      ⓘ Charged monthly for guests on autopay
                    </p>
                  )}

                {formData.bookingType === "Flexible" && (
                  <p className="tw-mt-2 tw-flex tw-items-center tw-justify-start">
                    ⓘ Charged monthly for guests on autopay or one time for all
                    other bookings
                  </p>
                )}
              </div>
            </div>
            <div className="col-lg-6 mb-2">
              <div>
                <label className="form-label">Security Deposit </label>
                <input
                  onChange={(e) => {
                    if (parseInt(e.target.value) >= 1 || e.target.value == "") {
                      handleStep(
                        "securityDeposite",
                        e.target.value
                          ? Math.floor(parseInt(e.target.value))
                          : ""
                      );
                    } else {
                      handleStep("securityDeposite", "");
                    }
                  }}
                  value={stepForm["securityDeposite"]}
                  type="text"
                  name="securityDeposite"
                  className="form-control"
                  placeholder="Security Deposit"
                  required
                />
                <p className="tw-mt-2 tw-flex tw-items-center tw-justify-start">
                  ⓘ Any guest who confirms a reservation at your listing will be
                  responsible for damages up to this amount. No charges or
                  authorizations will be made unless you make a claim within 48
                  hours after check out
                </p>
              </div>
            </div>

            {(formData.bookingType === "Cold bed" ||
              formData.bookingType === "Flexible") && (
              <div className="col-lg-6 mb-2">
                <div>
                  <label className="form-label">Lineholder Discount Type</label>
                  <select
                    onChange={(e) =>
                      handleStep("lineholderDiscountType", e.target.value)
                    }
                    value={stepForm["lineholderDiscountType"]}
                    name="lineholderDiscountType"
                    className="form-control wide"
                    required
                  >
                    <option value="">Select</option>
                    <option value="none">None</option>
                    <option value="Percentage">Percentage</option>
                    <option value="Fixed">Fixed</option>
                  </select>
                </div>
              </div>
            )}
            {(stepForm.lineholderDiscountType === "Percentage" ||
              stepForm.lineholderDiscountType === "Fixed") && (
              <div className="col-lg-6 mb-2">
                <div>
                  <label className="form-label">
                    Lineholder Discount{" "}
                    {stepForm.lineholderDiscountType === "Percentage" && "(%)"}
                  </label>
                  <input
                    onChange={(e) => {
                      if (e.target.value) {
                        if (
                          stepForm.lineholderDiscountType === "Percentage" &&
                          parseInt(e.target.value) >= 0 &&
                          parseInt(e.target.value) <= 99
                        ) {
                          handleStep(
                            "lineholderDiscount",
                            e.target.value
                              ? Math.floor(parseInt(e.target.value))
                              : ""
                          );
                        } else if (
                          stepForm.lineholderDiscountType === "Fixed" &&
                          parseInt(e.target.value) >= 0
                        ) {
                          handleStep(
                            "lineholderDiscount",
                            e.target.value
                              ? Math.floor(parseInt(e.target.value))
                              : ""
                          );
                        } else {
                          handleStep("lineholderDiscount", "");
                        }
                      } else {
                        handleStep("lineholderDiscount", "");
                      }
                    }}
                    value={stepForm["lineholderDiscount"]}
                    type="text"
                    name="lineholderDiscount"
                    className="form-control"
                    placeholder="Discount"
                    required
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div>
          <button
            onClick={onPrev}
            type="button"
            className="btn btn-secondary mx-2  tw-mb-2"
          >
            Prev
          </button>

          <button
            type="submit"
            disabled={updating}
            className="btn btn-secondary tw-mb-2"
          >
            {updating ? "Updating ..." : "Save & Next"}
          </button>
        </div>
      </div>
    </form>
  );
};

export const validatePricingAndFee = (formData = {}) => {
  const errors = [];
  const { rentalType, bookingType } = formData;

  if (
    rentalType === "Entire Place" &&
    (bookingType === "Hot bed" || bookingType === "Flexible")
  ) {
    if (!formData.perNightPrice || formData.perNightPrice <= 0) {
      errors.push({
        error: "Per Night Price is required and must be greater than 0",
        errorType: "pricing",
        field: "perNightPrice"
      });
    }
    if (formData.perNightPrice && !Number.isInteger(Number(formData.perNightPrice))) {
      errors.push({
        error: "Per Night Price must be a whole number",
        errorType: "pricing",
        field: "perNightPrice"
      });
    }
  }

  if (
    rentalType === "Entire Place" &&
    (bookingType === "Cold bed" || bookingType === "Flexible")
  ) {
    if (!formData.perMonthPrice || formData.perMonthPrice <= 0) {
      errors.push({
        error: "Per Month Price is required and must be greater than 0",
        errorType: "pricing",
        field: "perMonthPrice"
      });
    }
    if (formData.perMonthPrice && !Number.isInteger(Number(formData.perMonthPrice))) {
      errors.push({
        error: "Per Month Price must be a whole number",
        errorType: "pricing",
        field: "perMonthPrice"
      });
    }
  }

  if (rentalType === "Entire Place") {
    if (!formData.extraChargePerGuest || formData.extraChargePerGuest <= 0) {
      errors.push({
        error: "Extra Charge Per Guest is required and must be greater than 0",
        errorType: "pricing",
        field: "extraChargePerGuest"
      });
    }
    if (formData.extraChargePerGuest && !Number.isInteger(Number(formData.extraChargePerGuest))) {
      errors.push({
        error: "Extra Charge Per Guest must be a whole number",
        errorType: "pricing",
        field: "extraChargePerGuest"
      });
    }
  }

  if (formData.cleaningFee === "" || formData.cleaningFee === null || formData.cleaningFee === undefined) {
    errors.push({
      error: "Cleaning Fee is required",
      errorType: "fees",
      field: "cleaningFee"
    });
  }
  if (formData.cleaningFee !== "" && formData.cleaningFee !== null && formData.cleaningFee !== undefined) {
    if (formData.cleaningFee < 0) {
      errors.push({
        error: "Cleaning Fee cannot be negative",
        errorType: "fees",
        field: "cleaningFee"
      });
    }
    if (!Number.isInteger(Number(formData.cleaningFee))) {
      errors.push({
        error: "Cleaning Fee must be a whole number",
        errorType: "fees",
        field: "cleaningFee"
      });
    }
  }

  if (!formData.securityDeposite || formData.securityDeposite <= 0) {
    errors.push({
      error: "Security Deposit is required and must be greater than 0",
      errorType: "fees",
      field: "securityDeposite"
    });
  }
  if (formData.securityDeposite && !Number.isInteger(Number(formData.securityDeposite))) {
    errors.push({
      error: "Security Deposit must be a whole number",
      errorType: "fees",
      field: "securityDeposite"
    });
  }

  if (bookingType && (bookingType === "Cold bed" || bookingType === "Flexible")) {
    if (!formData.lineholderDiscountType) {
      errors.push({
        error: "Lineholder Discount Type is required",
        errorType: "discount",
        field: "lineholderDiscountType"
      });
    }

    if (
      formData.lineholderDiscountType === "Percentage" ||
      formData.lineholderDiscountType === "Fixed"
    ) {
      if (formData.lineholderDiscount === "" || formData.lineholderDiscount === null || formData.lineholderDiscount === undefined || formData.lineholderDiscount < 0) {
        errors.push({
          error: "Lineholder Discount is required and must be greater than or equal to 0",
          errorType: "discount",
          field: "lineholderDiscount"
        });
      }

      if (formData.lineholderDiscount !== "" && formData.lineholderDiscount !== null && formData.lineholderDiscount !== undefined) {
        if (!Number.isInteger(Number(formData.lineholderDiscount))) {
          errors.push({
            error: "Lineholder Discount must be a whole number",
            errorType: "discount",
            field: "lineholderDiscount"
          });
      }
    }
  }
  };
  return {
    isValid: errors.length === 0,
    errors: errors,
  }
};